import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/products/components/ProductsHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/products/components/ProductsList.tsx");
